import { Card } from "../ui/card"
import { ChevronLeft, ChevronRight, BookOpenCheck} from "lucide-react"
import { useParams, useNavigate } from "react-router-dom"
import useCourseStore from "../../store/courseStore"
import { useEffect } from "react"
import { useState } from "react"
import { cn } from "../../lib/utils"
import { Button } from "../ui/button"


export default function PaginationBar () {
  const { course_id, lesson_id} = useParams()
  const navigate = useNavigate()

  const { getCurrentLesson, getNextLesson, getPreviousLesson, lessons} = useCourseStore()

  const [lesson, setLesson] = useState(null)
  const handleCurrentLesson = async () => {
    try {
      const lesson = await getCurrentLesson(lesson_id)
      setLesson(lesson)
    } catch (error) {

    }
  }
  useEffect(() => {

    if (lesson_id) {
      handleCurrentLesson()
    }
  }, [lesson_id])

  const handleNext = async () => {
    try {
      const nextLesson = await getNextLesson(lesson.order)
      navigate(`/courses/${course_id}/lesson/${nextLesson.id}`)
    } catch (error) {

    }
  }
  const handlePrevious = async () => {
    try {
      const previousLesson = await getPreviousLesson(lesson.order)
      navigate(`/courses/${course_id}/lesson/${previousLesson.id}`)
    } catch (error) {

    }
  }

  if (!lesson) return
  return (
    <Card className="rounded-full flex justify-between gap-4 items-center p-4 w-max mx-auto">
      <Button variant="ghost"  onClick={() => handlePrevious()} disabled={lesson.order===1}>
      <ChevronLeft className={cn("cursor-pointer", lesson.order===1 ? "text-gray-300 cursor-not-allowed" : "")}/>
      </Button>

      <p className="text-xs">{lesson.title}</p>
      {
          lessons.length === lesson.order ?
      <Button variant="ghost" onClick={() => navigate(`/courses/${course_id}/test`)}>

          <BookOpenCheck className="cursor-pointer"/>

      </Button>
      :
      <Button variant="ghost" onClick={() => handleNext()} disabled={lessons.length === lesson.order }>
          <ChevronRight className="cursor-pointer"/>
      </Button>
    }
    </Card>
  )
}
